import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ensureLanguage, initialLanguage } from './locale/i18next';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Rus/ingliz tili tanlangan bo'lsa — lug'at kelgach chiziladi (o'zbekcha uchun kutish yo'q)
ensureLanguage(initialLanguage).then(() => root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
